export type BillboardCreateLaunchState = {
  from: 'billboard';
  billboardId: string;
  startDate?: string;
  endDate?: string;
  city?: string;
  screenName?: string;
  thumbnail?: string;
  addressLine?: string;
};

export function isBillboardCreateLaunch(
  state: unknown,
): state is BillboardCreateLaunchState {
  if (!state || typeof state !== 'object') return false;
  const s = state as Record<string, unknown>;
  return s.from === 'billboard' && typeof s.billboardId === 'string' && Boolean(s.billboardId);
}
